import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Card } from '../ui/card';
import { Thermometer, Droplets } from 'lucide-react';

const Step5Climate = ({ formData, updateFormData }) => {
  return (
    <div className="space-y-6 animate-fadeIn">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Climate Settings</h2>
        <p className="text-gray-600">Local climate conditions for accurate calculations</p>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="outsideTemp" className="text-base font-medium flex items-center">
            <Thermometer className="w-5 h-5 mr-2 text-red-500" />
            Outside Design Temperature (°C)
          </Label>
          <Input
            id="outsideTemp"
            type="number"
            min="20"
            max="50"
            value={formData.outsideTemp}
            onChange={(e) => updateFormData('outsideTemp', parseFloat(e.target.value) || 35)}
            className="h-12 text-lg border-blue-200 focus:border-blue-500 focus:ring-blue-500"
          />
          <p className="text-sm text-gray-500">
            Default for Algarve: 35°C (summer peak)
          </p>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="insideTemp" className="text-base font-medium flex items-center">
            <Thermometer className="w-5 h-5 mr-2 text-blue-500" />
            Desired Indoor Temperature (°C)
          </Label>
          <Input
            id="insideTemp"
            type="number"
            min="18"
            max="26"
            value={formData.insideTemp}
            onChange={(e) => updateFormData('insideTemp', parseFloat(e.target.value) || 22)}
            className="h-12 text-lg border-blue-200 focus:border-blue-500 focus:ring-blue-500"
          />
          <p className="text-sm text-gray-500">
            Recommended: 22°C for comfort
          </p>
        </div>
      </div>
      
      <Card className="p-4 bg-blue-50 border-blue-200">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-blue-700 font-medium">Temperature Difference</p>
            <p className="text-3xl font-bold text-blue-900">
              {formData.outsideTemp - formData.insideTemp}°C
            </p>
          </div>
          <Thermometer className="w-12 h-12 text-blue-700 opacity-50" />
        </div>
      </Card>
      
      <div className="space-y-2">
        <Label htmlFor="humidityLevel" className="text-base font-medium flex items-center">
          <Droplets className="w-5 h-5 mr-2 text-blue-400" />
          Humidity Considerations
        </Label>
        <Select value={formData.humidityLevel} onValueChange={(value) => updateFormData('humidityLevel', value)}>
          <SelectTrigger className="h-12 text-lg border-blue-200 focus:border-blue-500 focus:ring-blue-500">
            <SelectValue placeholder="Select humidity level" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="standard">Standard - Normal humidity</SelectItem>
            <SelectItem value="high">High Humidity Area - Near coast/water</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-sm text-gray-500">
          High humidity areas may require additional cooling capacity
        </p>
      </div>
      
      <Card className="p-4 bg-amber-50 border-amber-200">
        <div className="flex items-start space-x-3">
          <div className="text-amber-600 text-2xl">ℹ️</div>
          <div>
            <p className="text-sm font-medium text-amber-900">Climate Note</p>
            <p className="text-sm text-amber-700 mt-1">
              The Algarve region typically experiences hot, dry summers with peak temperatures around 35°C. 
              These preset values are optimized for this climate.
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Step5Climate;